





























































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { Modal } from '@/components/general'
import { DiscountConrolTableList, DiscountControlFormCreateEdit, FiltersDiscountControl as Filters } from '@/components/dailyControl'

// services
import { DiscountControlService } from '@/services/dailyControl'

// models
import { Paginator } from '@/models'
import { DiscountControl, DiscountControlForm, FiltersDiscountControl } from '@/models/dailyControl'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'
import { TYPE_PERCENTAGE, TYPE_AMOUNT } from '@/constants/discountTypeConstants'

const discountControlDefault: DiscountControlForm = {
  employee_id: null,
  date: null,
  amount: 0,
  type: 1,
  discount_type_id: null,
  observations: null,
  frequency: null
}

export default defineComponent({
  name: 'DiscountControlIndex',
  components: {
    PageHeader,
    DiscountConrolTableList,
    Modal,
    DiscountControlFormCreateEdit,
    ButtonExport,
    AccordionFilters,
    Filters
  },
  setup () {
    const showModal = ref(false)
    const title = 'Control de Descuentos'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Control de Descuento'
      }
      return 'Crear Control de Descuento'
    })
    const items = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Control de Descuentos',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const filters: Ref<FiltersDiscountControl> = ref({
      dateStart: null,
      dateEnd: null,
      employee: null,
      discountType: null
    })
    const discountControl: Ref<DiscountControlForm> = ref(discountControlDefault)
    const discountControls: Ref<DiscountControl[]> = ref([])
    const getDiscountControlWithPagination = async () => {
      loading('show')
      const res = await DiscountControlService.getWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      pagination.value = res.pagination
      discountControls.value = res.objects
      loading('hide')
    }
    getDiscountControlWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      discountControl.value = {
        ...discountControlDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      discountControl.value = {
        ...discountControlDefault
      }
      idEdit.value = null
      getDiscountControlWithPagination()
    }
    const editItem = (item: DiscountControl) => {
      discountControl.value = {
        employee_id: item.employee_id,
        date: item.date,
        amount: item.amount,
        discount_type_id: item.discount_type_id,
        type: item.type,
        observations: item.observations,
        frequency: item.frequency
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: DiscountControl) => {
      const msg = `Seguro que desea eliminar el Control de Descuento del empleado: ${item.employee.fullName}, con fecha de: ${item.date}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await DiscountControlService.delete(item.id)
        alerts.success()
        getDiscountControlWithPagination()
      }
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getDiscountControlWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getDiscountControlWithPagination()
    }

    const headersExcel = [
      { text: 'Fecha', value: 'date' },
      { text: 'Empleado', value: 'employee' },
      { text: 'Tipo de Descuento', value: 'discountType' },
      { text: 'Por Porcentaje', value: 'is_percentage' },
      { text: 'Por Importe', value: 'is_amount' },
      { text: 'Valor', value: 'amount_text' },
      { text: 'Observaciones', value: 'observations' }
    ]

    const allDiscountControl: Ref<DiscountControl[]> = ref([])

    const itemsExcel = computed(() => {
      return allDiscountControl.value.map(item => {
        return {
          ...item,
          employee: getFullNameFormat(item.employee),
          discountType: item.discountType.name,
          is_percentage: item.type === TYPE_PERCENTAGE ? 'SI' : 'NO',
          is_amount: item.type === TYPE_AMOUNT ? 'SI' : 'NO'
        }
      })
    })

    const getAllitems = async () => {
      allDiscountControl.value = await DiscountControlService.getAll(filters.value)
    }

    const getByFilters = () => {
      pagination.value.currentPage = 1
      getDiscountControlWithPagination()
    }

    const clearFilters = () => {
      pagination.value.currentPage = 1
      filters.value = {
        dateStart: null,
        dateEnd: null,
        employee: null,
        discountType: null
      }
      getDiscountControlWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      saveSuccess,
      allDiscountControl,
      discountControl,
      discountControls,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      headersExcel,
      itemsExcel,
      getAllitems,
      filters,
      getByFilters,
      clearFilters
    }
  }
})
